import React from "react";
import {
  Document,
  PDFDownloadLink,
  Page,
  StyleSheet,
} from "@react-pdf/renderer";
import { Button } from "@mui/material";
import Title from "./elements/Title";
import Body from "./elements/Body";
// import Header from "./elements/Header";
// import Body from "./elements/Body";

const Mejora = ({ data }) => {
  const styles = StyleSheet.create({
    page: {
      fontFamily: "Helvetica",
      fontSize: 11,
      paddingTop: 30,
      paddingLeft: 40,
      paddingRight: 40,
      lineHeight: 1.5,
      flexDirection: "column",
    },
  });

  return (
    <PDFDownloadLink
      document={
        <Document>
          <Page size="A4" style={styles.page}>
            <Title />
            <Body data={data} />
          </Page>
        </Document>
      }
      fileName={"solicitud-mejoramiento-maquina.pdf"}
    >
      <Button
        fullWidth
        color="secondary"
        variant="contained"
        sx={{ height: 45 }}
      >
        MEJORA
      </Button>
    </PDFDownloadLink>
  );
};

export default Mejora;
